export type CapTableResetMode = 'start_fresh' | 'clear_ai_evidence' | 'clear_pending';

export type CapTableResetApiMode = 'start_fresh' | 'clear_ai_evidence' | 'clear_ai_suggestions';

export const CAP_TABLE_RESET_API_MODE: Record<CapTableResetMode, CapTableResetApiMode> = {
  start_fresh: 'start_fresh',
  clear_ai_evidence: 'clear_ai_evidence',
  clear_pending: 'clear_ai_suggestions',
};

export const CAP_TABLE_RESET_COPY: Record<CapTableResetMode, { title: string; remains: string }> = {
  start_fresh: {
    title: 'Clear all references and citations',
    remains:
      'Removes every review card, PDF citation and Excel reference on this cap table, the ones a person added as well as the ones the AI added. Entered values and securities stay exactly as they are, and the next AI run behaves like a first run.',
  },
  clear_ai_evidence: {
    title: 'Clear only AI references and citations',
    remains:
      'Removes every AI review card, whether it is still pending or you already accepted or rejected it, along with every PDF citation and Excel reference the AI added. Citations and references a person added stay, and entered values and securities stay exactly as they are.',
  },
  clear_pending: {
    title: 'Clear pending AI references and citations',
    remains:
      'Removes the AI review cards you have not decided on yet, and every AI citation or Excel reference still waiting on a decision, including ones sitting on cards you already accepted or rejected. Those cards keep only the citations and references you have already decided on, and entered values and securities stay exactly as they are.',
  },
};

/**
 * Names what a finished clear action actually removed, so the toast matches the mode the analyst picked.
 * Counts only citations and references: the server's card count covers value cards alone, so a
 * citation-only card can vanish without being counted.
 */
export const capTableResetSummary = (
  mode: CapTableResetMode,
  result: { citations_cleared: number; excel_references_removed: number }
) => {
  const counted = (value: number, noun: string) => `${value} ${noun}${value === 1 ? '' : 's'}`;
  const citations = counted(result.citations_cleared, 'citation');
  const references = counted(result.excel_references_removed, 'Excel reference');
  return `${CAP_TABLE_RESET_COPY[mode].title}: removed ${citations} and ${references}. Values are unchanged.`;
};
